export default "__VITE_ASSET__Dc3r8gd6__"